/*<!-- heatmap.com snippet -->*/
  (function() {      
    var _heatmap_paq = window._heatmap_paq || [];
    var heatUrl = window.heatUrl = "https://dashboard.heatmap.com/";
    function heatLoader(url, item) {
      if(typeof handleSinglePagedWebsite !== 'undefined' && item == 'prep') return true;
      var s = document.createElement("script"); s.type = "text/javascript"; 
      s.src = url; s.async = false; s.defer = true; document.head.appendChild(s);
    }
    heatLoader(heatUrl+"preprocessor.min.js?sid=3103", "prep");
    setTimeout(function() {
      if(typeof _heatmap_paq !== "object" || _heatmap_paq.length == 0) {     
        _heatmap_paq.push(["setTrackerUrl", heatUrl+"heatmap.php"]);
        heatLoader(heatUrl+"heatmap-light.min.js?sid=3103", "heat");
      }
    }, 1000);
  })();
/*<!-- End heatmap.com snippet Code -->*/